import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AppProvider } from '@/app/AppContext'
import { Router } from '@/app/Router'
// Шрифты из npm, а не с Google Fonts: стенд открывают из России, и внешний CDN — лишний
// запрос наружу и лишний риск блокировки. Кириллица входит в пакет.
import '@fontsource/ibm-plex-sans/400.css'
import '@fontsource/ibm-plex-sans/500.css'
import '@fontsource/ibm-plex-sans/600.css'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/500.css'
import '@/styles/crm.css'
import '@/styles/crm-extra.css'
import '@/styles/app.css'
// Last: the narrow-screen rules (#109) override the desktop ones above and in the screens.
import '@/styles/responsive.css'
import { userManager } from '@/auth/oidc'
import { UnsubscribePage } from '@/notifications/UnsubscribePage'

/**
 * Точка входа (ТЗ §5.1).
 */

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Данные не перезапрашиваются при возврате фокуса на вкладку: в CRM человек
      // переключается между окнами постоянно, и обновление списка под курсором
      // сбивает выделение ровно в момент клика.
      refetchOnWindowFocus: false,
      // Один повтор: сетевой сбой бывает, но три попытки к упавшему серверу
      // растягивают ошибку на десяток секунд, и пользователь считает, что висит.
      retry: 1,
      staleTime: 30 * 1000,
    },
  },
})

const root = document.getElementById('root')
if (!root) throw new Error('Не найден корневой элемент #root')

if (window.location.pathname === '/silent-renew') {
  void userManager.signinSilentCallback().catch(() => { root.textContent = 'Не удалось обновить сессию' })
} else if (window.location.pathname === '/unsubscribe') {
  // Ссылка из письма-уведомления (#118): без входа и мимо AppProvider, который требует сессию.
  createRoot(root).render(
    <StrictMode>
      <UnsubscribePage />
    </StrictMode>,
  )
} else createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppProvider>
          <Router />
        </AppProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
